export function getDateFormatBasedOnData(users) {
  return users.some(({ birthdate }) => {
    const month = birthdate ? birthdate.split('/')[1] : '1';
    return parseInt(month) > 12;
  })
    ? 'MM/DD/YYYY'
    : 'DD/MM/YYYY';
}
